module.exports = __webpack_public_path__ + "static/img/bg2.4bfc4040.png";